
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk pour récupérer les FAQs avec pagination
export const fetchFaqs = createAsyncThunk(
  'faqs/fetchFaqs',
  async ({ page = 1, itemsPerPage = 5, url = null }, { rejectWithValue }) => {
    try {
      const apiUrl = url || `${process.env.REACT_APP_API_URL}faqs?page=${page}&per_page=${itemsPerPage}`;
      const response = await axios.get(apiUrl);
      return response.data;
    } catch (error) {
      // console.error('API Error:', error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// État initial
const initialState = {
  data: {
    title: '',
    description: '',
    faqs: [],
  },
  status: 'idle',            // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,               // message d'erreur
  currentPage: 1,            // page actuelle
  totalItems: 0,             // total d'éléments
  itemsPerPage: 5,           // éléments par page
  totalPages: 1,             // nombre total de pages
  next_page_url: null,       // lien vers la page suivante
  prev_page_url: null,       // lien vers la page précédente
};

// Slice
const faqsSlice = createSlice({
  name: 'faqs',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
      state.currentPage = 1; // On revient à la page 1
    },
    resetFaqs: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = {
          title: action.payload.title || 'Questions fréquentes',
          description: action.payload.description || 'Retrouvez les réponses à vos questions ici.',
          faqs: action.payload.data || action.payload.faqs || [],
        };
        state.currentPage = action.payload.current_page || 1;
        state.totalItems = action.payload.total || 0;
        state.itemsPerPage = action.payload.per_page || state.itemsPerPage;
        state.totalPages = action.payload.last_page || 1;
        state.next_page_url = action.payload.next_page_url;
        state.prev_page_url = action.payload.prev_page_url;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || { message: 'Une erreur inattendue est survenue' };
      });
  },
});

// Exports des actions
export const { setCurrentPage, setItemsPerPage, resetFaqs } = faqsSlice.actions;

// Export du reducer
export default faqsSlice.reducer;
